import type { FaireProductEntity } from "../../entity_types/product";

export const p_8c37bwcmvm: FaireProductEntity = {
  token: "p_8c37bwcmvm",
  type: "product",
  name: "Love You Grandpa Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/42929c3648da1b03338f958bbec08a0da2da05f13098159c2309a0c1854370bc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08af39e8d7bf2a693f4cd15c3def6a96ba94ce67d3e15e463b5dd95a328bb211.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:33.284Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
